import {useState} from "react";

export type DigitalWorkflow={
  id:string;
  kind:string;
  mode:string;
  status:string;
  requested_by:string;
  approved_by?:string|null;
  error_code?:string|null;
  created_at_ms?:number;
};

const label:Record<string,string>={
  "analyst.snapshot":"Analista · estado del negocio",
  "logistics.route_proposal":"Logística · propuesta de ruta",
  "growth.followup_draft":"Crecimiento · borrador de seguimiento",
};
const states:Record<string,string>={
  waiting_approval:"Necesita aprobación",
  ready:"Listo para worker",
  leased:"Procesando",
  completed:"Completado",
  review_required:"Revisión manual",
};
interface Props {
  jobs:DigitalWorkflow[];
  canApprove:boolean;
  disabled?:boolean;
  onCreate:()=>Promise<void>;
  onApprove:(id:string)=>Promise<void>;
}
export function DigitalWorkforce({jobs,canApprove,disabled=false,onCreate,onApprove}:Props){
 const [working,setWorking]=useState<string|null>(null),[error,setError]=useState("");
 const action=async(id:string,job:()=>Promise<void>)=>{
  if(working||disabled)return;setWorking(id);setError("");
  try{await job()}catch(e){setError(e instanceof Error?e.message:"No fue posible completar la operación.")}
  finally{setWorking(null)}
 };
 return <section className="ct-workforce" aria-label="Equipo digital">
  <header className="ct-head">
   <div><h1>Equipo digital</h1>
    <p>Solicitudes de agentes con permisos, aprobación, historial y ejecución independiente.</p></div>
   <button className="ct-btn" type="button" disabled={disabled||working!==null}
    onClick={()=>void action("new",onCreate)}>Solicitar análisis</button>
  </header>
  <div className="ct-card ct-workforce-notice" role="note">
   <strong>Autonomía supervisada</strong>
   <p>Solicitar análisis crea una tarea durable. No ejecuta cobros, envía WhatsApp ni dispara rutas. Los agentes aprobados necesitan un worker privado con autorización vigente para ejecutarse.</p>
  </div>
  {error&&<div className="ct-error" role="alert">{error}</div>}
  {!jobs.length?<div className="ct-empty">No hay tareas de agentes para esta empresa.</div>:
  <div className="ct-workflow-list" role="list">{jobs.map(job=><article className="ct-workflow" role="listitem" key={job.id}>
   <div className="ct-workflow-main">
    <strong>{label[job.kind]??job.kind}</strong>
    <p>{states[job.status]??job.status} · {job.mode==="autonomous_limited"?"Autonomía acotada":"Asistido"}</p>
    <small>{Number.isFinite(job.created_at_ms)?new Date(job.created_at_ms!).toLocaleString("es-AR"):"Registro persistido"} · ID {job.id.slice(0,8)}</small>
    {job.error_code&&<span className="ct-workflow-warning">Requiere revisión: {job.error_code}</span>}
   </div>
   {job.status==="waiting_approval"&&canApprove&&
    <button type="button" className="ct-btn ct-outline" disabled={disabled||working!==null}
     onClick={()=>void action(job.id,()=>onApprove(job.id))}>Aprobar tarea</button>}
  </article>)}</div>}
 </section>;
}
